import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import { FaChevronDown } from "react-icons/fa";
import "react-calendar/dist/Calendar.css";

const DateRangePicker = ({
  onRangeChange,
  placeholder = "Seleccionar rango",
  selectRange,
  startDate: propStartDate,
  endDate: propEndDate,
  loading = false,
}) => {
  const [startDate, setStartDate] = useState(propStartDate || null);
  const [endDate, setEndDate] = useState(propEndDate || null);
  const [isOpen, setIsOpen] = useState(false);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start && end && onRangeChange) {
      onRangeChange({ startDate: start, endDate: end });
      setIsOpen(false);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (propStartDate && propEndDate) {
      setStartDate(propStartDate);
      setEndDate(propEndDate);
    }
  }, [propStartDate, propEndDate]);

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        minWidth: 155,
      }}
    >
      <div
        onClick={() => !loading && setIsOpen(!isOpen)}
        className="rounded-md px-4 py-2 text-xs cursor-pointer flex items-center justify-between"
        style={{
          backgroundColor: loading ? "#e0e0e0" : "#F3F3F3",
          color: loading ? "#b0b0b0" : "#8F99A6",
          height: 40,
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        <span>
          {startDate && endDate && selectRange
            ? `${startDate.toLocaleDateString(
                "es-ES"
              )} - ${endDate.toLocaleDateString("es-ES")}`
            : placeholder}
        </span>
        <FaChevronDown style={{ marginLeft: "10px" }} />
      </div>

      {isOpen && !loading && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "5px",
            padding: "10px",
            zIndex: 1000,
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Calendar
            selectRange
            value={startDate && endDate ? [startDate, endDate] : null}
            onChange={handleDateChange}
            locale="es-ES"
            tileClassName={({ date }) => {
              let className = "";
              if (
                startDate &&
                date.toLocaleDateString() === startDate.toLocaleDateString()
              ) {
                className = "start-date";
              }
              if (
                endDate &&
                date.toLocaleDateString() === endDate.toLocaleDateString()
              ) {
                className = "end-date";
              }
              if (
                startDate &&
                endDate &&
                date >= startDate &&
                date <= endDate &&
                date.toLocaleDateString() !== startDate.toLocaleDateString() &&
                date.toLocaleDateString() !== endDate.toLocaleDateString()
              ) {
                className = "range-date";
              }
              return className;
            }}
          />
          <button
            onClick={handleClose}
            style={{
              marginTop: "10px",
              padding: "5px 10px",
              border: "none",
              backgroundColor: "#be202f",
              color: "#fff",
              borderRadius: "5px",
              cursor: "pointer",
              width: "100%",
            }}
          >
            Cerrar
          </button>
        </div>
      )}

      <style>{`
        .react-calendar__tile--active {
          background: #be202f !important;
        }
        .start-date {
          background-color: #d9727c !important;
          color: #fff !important;
        }
        .end-date {
          background-color: #d9727c !important;
          color: #fff !important;
        }
        .range-date {
          background-color: #f5f5f5 !important;
          color: black !important;
        }
      `}</style>
    </div>
  );
};

export default DateRangePicker;
